import React from 'react';

export default function Callout({ title, children, variant = 'green' }) {
  const colors = {
    green: { bg: 'var(--gpale)', border: 'var(--g2)', title: 'var(--g2)' },
    dark:  { bg: 'var(--dark)', border: 'var(--g2)', title: 'var(--g2)' },
  };
  const c = colors[variant] || colors.green;

  return (
    <div style={{
      background: c.bg,
      borderLeft: `4px solid ${c.border}`,
      borderRadius: '0 8px 8px 0',
      padding: '20px 24px',
      margin: '24px 0',
    }}>
      {title && (
        <div style={{ fontSize: 13, fontWeight: 600, color: c.title, marginBottom: 6 }}>
          {title}
        </div>
      )}
      <div style={{ fontSize: 14, color: variant === 'dark' ? 'rgba(255,255,255,0.65)' : 'var(--ink)', lineHeight: 1.7 }}>
        {children}
      </div>
    </div>
  );
}
